module.exports = "<template>\r\n\t<md-switch checked.two-way=\"value\" label-off=\"\" label-on=\"\"></md-switch>\r\n</template>";